import DTO from './DTO';
import DtoType from './converters/DtoType';
import ZoneDTO from './ZoneDTO';

class ViolationDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'id',
        type: String,
        validators: [],
        labelKey: 'id',
      },
      {
        name: 'date',
        type: String,
        validators: [],
        labelKey: 'violation.date',
      },
      {
        name: 'type',
        type: String,
        validators: [],
        labelKey: 'violation.type',
      },
      {
        name: 'violation_type',
        type: String,
        validators: [],
        labelKey: 'violation.type',
      },
      {
        name: 'vehicle_id',
        type: String,
        validators: [],
        labelKey: 'violation.vehicle_id',
      },
      {
        name: 'provider_id',
        type: String,
        validators: [],
        labelKey: 'violation.provider_id',
      },
      {
        name: 'provider_name',
        type: String,
        validators: [],
        labelKey: 'violation.provider_id',
      },
      {
        name: 'zone_id',
        type: String,
        validators: [],
        labelKey: 'violation.zone',
      },
      {
        name: 'zone_name',
        type: String,
        validators: [],
        labelKey: 'violation.zone',
      },
      {
        name: 'zone',
        type: DtoType(ZoneDTO),
        validators: [],
        labelKey: 'violation.zone',
      },
      {
        name: 'operator',
        type: String,
        validators: [],
        labelKey: 'violation.operator',
      },
      {
        name: 'status',
        type: String,
        validators: [],
        labelKey: 'violation.status',
      },
      {
        name: 'statuses',
        type: String,
        validators: [],
        labelKey: 'status',
      },
      {
        name: 'coordinates',
        type: String,
        validators: [],
        labelKey: 'coordinates',
      },
      {
        name: 'inspector',
        type: String,
        validators: [],
        labelKey: 'inspector',
      },
      {
        name: 'inspector_id',
        type: String,
        validators: [],
        labelKey: 'inspector',
      },
      {
        name: 'inspector_login',
        type: String,
        validators: [],
        labelKey: 'violation.inspector_login',
      },
      {
        name: 'vehicle_type',
        type: String,
        validators: [],
        labelKey: 'vehicles.vehicle_type',
      },
      {
        name: 'photos',
        type: Array,
        validators: [],
        labelKey: 'violation.photos',
      },
      {
        name: 'location',
        type: String,
        validators: [],
        labelKey: 'violation.location',
      },
      {
        name: 'created_at',
        type: String,
        validators: [],
        labelKey: 'created_at',
      },
      {
        name: 'updated_at',
        type: String,
        validators: [],
        labelKey: 'updated_at',
      },
      {
        name: 'description',
        type: String,
        validators: [],
        labelKey: 'description',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {
      last_name: this.last_name,
      first_name: this.first_name,
      middle_name: this.middle_name,
    };
  }
}

export default ViolationDTO;
